import { html } from "@microsoft/fast-element";
import { WizardPanel } from "./wizard-panel.js";
/**
 * The template for the {@link @fabric-msft/fabric-web#(WizardPanel:class)} component.
 * @public
 */
export function wizardPanelTemplate() {
    return html `
    <template
      aria-hidden="${(x) => x.hidden}"
      state="${(x) => x.state}"
      ?active="${(x) => x.active}"
      ?hidden="${(x) => x.hidden}"
      slot="panel"
    >
      <div class="panel" part="panel">
        <slot name="start"></slot>
        <div class="title" part="title">
          <slot name="title"></slot>
        </div>
        <div class="content" part="content"><slot></slot></div>
        <div class="footer" part="footer"><slot name="footer"></slot></div>
        <slot name="end"></slot>
      </div>
    </template>
  `;
}
export const template = wizardPanelTemplate();
//# sourceMappingURL=wizard-panel.template.js.map